import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';
import numbro from 'numbro';

import Utils from 'utils/Utils.js';
import Ring from 'modules/misc/Ring.js';

import styleDef from './style.js';
var style = {
    ...styleDef,
};

const DailyCard = ({t, pinnedItem, onNavigate}) => (
            <Card style={style.card} onClick={()=>onNavigate(pinnedItem)}>
                <div style={style.iconHeader}>
                    <Ring style={style.ring} 
                            completeFactor={pinnedItem.progressCount/pinnedItem.progressMax} 
                            width="75px" 
                            height="75px" 
                            innerCirclePercent="85"/>
                    {pinnedItem.icon &&
                        <Icon style={style.icon} size='huge' className={pinnedItem.icon}></Icon> 
                    }
                </div>
                <Card.Content style={style.cardContent}>
                    <Card.Header style={style.header} textAlign='center'>
                       <div style={style.value}>{numbro(pinnedItem.progressCount).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})} </div>
                        {pinnedItem.title}
                    </Card.Header>
                </Card.Content>
            </Card>
);
export default translate('challenges')(DailyCard);



// WEBPACK FOOTER //
// ./src/modules/challenges/customCards/DailyCard.js